// @ts-nocheck
import { createTheme } from '@material-ui/core/styles'

export const theme = createTheme({
  typography: {
    fontWeightMedium: 300,
    fontWeightRegular: 300,
    fontWeightLight: 300,
    allVariants: {
      fontWeight: 300,
    },
    h1: {
      fontWeight: 300,
    },
    h2: {
      fontWeight: 300,
    },
    h3: {
      fontWeight: 300,
    },
    h4: {
      fontWeight: 300,
    },
    h5: {
      fontWeight: 300,
    },
    button: {
      fontWeight: 300,
    },
  },
  palette: {
    // primary: {
    //   // main: '#5050aa',
    // },
    // secondary: {
    //   main: '#9999ff',
    // },
    // background: {
    //   default: '#000000',
    // },
    // type: 'dark',
  },
})
